import './GlobalFontSizeVariables.css';
export var fontSizeWrapper = '_eom86z0-3-12-1';